import { Routes } from '@angular/router';
import { DesktopCategoryPageComponent } from '../../components/desktop/desktop-category-page/desktop-category-page.component';
import { loginTrx, signUpTrx } from 'src/app/router-translation.labels';
import { LoginDialogRouteComponent } from 'src/app/components/auth/login-dialog/login-dialog.component';

const loginRoute = {
  path: loginTrx,
  component: LoginDialogRouteComponent
};

export const signupDialogRoute = {
  path: signUpTrx,
  loadChildren: () => import('../../modules/signup/signup-dialog.module').then(m => m.SignupDialogModule)
};

export const DESKTOP_CATEGORIES_MODULE_NOT_TRANSLATED: Routes = [
  {
    path: '',
    component: DesktopCategoryPageComponent,
    children: [
      loginRoute,
      signupDialogRoute,
    ]
  },
];
